import { isEmptyString } from "@/utils"

export const required = value => {
  if (value === "" || value === null || value === undefined) {
    return "The field is requied"
  }
}

export const maxSize = max => value => {
  if (value && value.length > max) {
    return ["The field length must be less than {0}", max + 1]
  }
}

export const size = (min, max = Infinity) => value => {
  if (!value || min > value.length || value.length > max) {
    return max === Infinity
      ? ["The field length must be at least {0}", min]
      : ["The field length must be from {0} to {1}", min, max]
  }
}

export const nonEmpty = value => {
  if (isEmptyString(value)) {
    return "The field must be non-empty"
  }
}

export const regexp = (regexp, alias) => value => {
  if (!regexp.test(value)) {
    return ["The field must match pattern {0}", alias]
  }
}

const emailRegexp = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/
export const email = value => {
  if (!emailRegexp.test(value)) {
    return "The field must be a valid email"
  }
}

export const sameAsValue = (asValue, asAlias) => value => {
  if (asValue !== value) {
    return ["The field must have a same value as {0}", asAlias]
  }
}

export const sameAsFn = (asFn, asAlias) => (value, scope) => {
  if (asFn.call(scope) !== value) {
    return ["The field must have a same value as {0}", asAlias]
  }
}

export const floatFixed = fixed => value => {
  const fixedValue = parseFloat(parseFloat(value).toFixed(fixed))
  if (value !== fixedValue) {
    return ["The number field must have fixed point at most {0} length", fixed]
  }
}

export const maxSelected = max => value => {
  if (value && value.length > max) {
    return ["Number of selected items must be less than {0}", max + 1]
  }
}

export const customValidation = validateFn => (value, scope) => {
  return validateFn.call(scope, value)
}

export const nonBlank = value => {
  if (value && value.trim && value.trim() === "") {
    return "The field must be non blank"
  }
}
